"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseRpcRequest = void 0;
class BaseRpcRequest {
    constructor(params, id = 1) {
        this.jsonrpc = "2.0";
        this.params = params;
        this.id = id;
    }
}
exports.BaseRpcRequest = BaseRpcRequest;
//# sourceMappingURL=rpc-request.type.js.map